const timeLineMessages = {
  'timeLine.timeLineLists.status.confirm': '確',
  'timeLine.timeLineLists.title.status': '状況',
  'timeLine.timeLineLists.title.data': 'データ',
  'timeLine.timeLineLists.title.position': '位置情報',
  'timeLine.timeLineLists.title.recordedDate': '記録日時',
  'timeLine.timeLineLists.title.savedDate': '保存日時',
  'timeLine.timeLineLists.title.operator': '作業者',
  'timeLine.timeLineLists.title.deviceName': 'デバイス名',
  'timeLine.timeLineLists.title.deviceNickname': 'デバイス表示名',
  'timeLine.timeLineLists.title.groupName': 'グループ名',
  'timeLine.timeLineLists.title.serialNumber': '端末シリアル',
  'timeLine.timeLineLists.title.underAnalysis': '解析データ',
  'timeLine.timeLineLists.title.tags': 'タグ',
  'timeLine.timeLineLists.title.greater': ' > ',
  'timeLine.timeLineLists.title.deleteDate': '削除日',
  'timeLine.timeLineLists.title.comment': 'コメント',
  'timeLine.timeLineLists.title.operation': '操作',
  'timeLine.timeLineLists.lists.position.yes': 'あり',
  'timeLine.timeLineLists.lists.position.no': 'なし',
  'timeLine.timeLineLists.lists.moveShare': '映像共有',
  'timeLine.timeLineLists.lists.chat': 'チャット',
  'timeLine.timeLineLists.lists.noAnalysis': '未解析',
  'timeLine.timeLineLists.lists.underAnalysis': '解析中...',
  'timeLine.timeLineLists.lists.analyzed': '解析完了',
  'timeLine.timeLineSearchBox.title.recordedDateFrom': '記録日時',
  'timeLine.timeLineSearchBox.title.savedDateFrom': '保存日時',
  'timeLine.timeLineSearchBox.title.partialOperatorName': '作業者',
  'timeLine.timeLineSearchBox.title.partialDeviceNickname': 'デバイス表示名',
  'timeLine.timeLineSearchBox.title.partialTagName': 'タグ',
  'timeLine.timeLineSearchBox.title.freeTag': 'メモ',
  'timeLine.timeLineSearchBox.title.hierarchicalTag': 'タグ',
  'timeLine.timeLineSearchBox.title.greater': '>',
  'timeLine.timeLineSearchBox.title.group': 'グループ',
  'timeLine.timeLineSearchBox.fullTilde': '～',
  'timeLine.timeLineSearchBox.label.unsetTagOnly': '未設定項目を絞り込み表示',
  'timeLine.timeLineSearchBox.label.showTagSetting': 'タグ表示設定',
  'timeLine.timeLineSearchBox.label.useTag': '利用可能',
  'timeLine.timeLineSearchBox.label.deleteTag': '削除済み',
  'timeLine.timeLineSearchBox.label.allTag': '全て',
  'timeLine.timeLineSearchBox.placeholder.partialOperatorName':
    '作業者名で絞り込み',
  'timeLine.timeLineSearchBox.placeholder.partialDeviceNickname':
    'デバイス表示名で絞り込み',
  'timeLine.timeLineSearchBox.placeholder.freeTag': '複数入力はスペース区切り',
  'timeLine.timeLineSearchBox.button.saveSearchCriteria': '検索条件保存',
  'timeLine.timeLineSearchBox.button.download': '一括ダウンロード',
  'timeLine.timeLineSearchBox.button.dataDelete': '削除',
  'timeLine.timeLineSearchBox.button.searchTag': 'タグを検索',
  'timeLine.timeLineSearchBox.select.depth': '階層{depth}',
  'timeLine.timeLineSearchBox.toast.saveSearchCriteria':
    'デフォルトの検索条件として保存しました。',
  'timeLine.timeLineToolBar.checked': 'チェックした項目を',
  'timeLine.timeLineToolBar.select': '選択してください',
  'timeLine.timeLineToolBar.execute': '実行',
  'timeLine.timeLineToolBar.download': 'ダウンロード',
  'timeLine.timeLineToolBar.download.checkResult':
    '改ざんチェック結果ダウンロード',
  'timeLine.timeLineToolBar.editTag': 'タグ・メモ編集',
  'timeLine.timeLineToolBar.delete': '削除',
  'timeLine.timeLineToolBar.restore': '復元',
  'timeLine.timeLineToolBar.completeDelete': '完全削除',
  'timeLine.timeLineToolBar.postUrls': '転送',
  'timeLine.timeLineToolBar.allCheck': 'すべてチェック',
  'timeLine.title': '写真一覧',
  'timeLine.dashboard.title': '新着写真',
  'timeLine.storage': 'ストレージ：{storage} GB',
  'timeline.trash': '最近削除した項目',
  'timeLine.nodata': 'NO DATA',
  'timeLine.selectGroup': 'グループを選択してください。',
  'timeline.pagenation.unit': '件',
  'timeLine.tagSearch.title': 'タグを検索',
  'timeLine.updateTagsDialog.title': 'タグ・メモの編集',
  'timeLine.updateTagsDialog.depth': '階層 {depth}',
  'timeLine.updateTagsDialog.updateTab': '上書き編集',
  'timeLine.updateTagsDialog.clearTab': '削除',
  'timeLine.updateTagsDialog.updateMsg1':
    '選択したデータのメモ・タグを上書き編集をします。',
  'timeLine.updateTagsDialog.updateMsg2': '※空欄の場合は上書きされません。',
  'timeLine.updateTagsDialog.clearMsg1':
    '選択したデータに付与されているタグ・メモをすべて削除します。',
  'timeLine.updateTagsDialog.clearMsg2': '削除する項目を選択してください。',
  'timeLine.updateTagsDialog.freeTag': 'メモ',
  'timeLine.updateTagsDialog.masterTag': 'タグ',
  'timeLine.updateTagsDialog.cancel': 'キャンセル',
  'timeLine.updateTagsDialog.update': '更新',
  'timeLine.updateTagsDialog.errorMessage':
    '複数のタグが設定されているため、タグを更新できません',
  'timeLine.updateTagsDialog.clearWarning1':
    '以下のメモが削除されますがよろしいですか？',
  'timeLine.updateTagsDialog.clearWarning2':
    '以下のタグが削除されますがよろしいですか？',
  'timeLineTile.title': 'データ',
  'timeLineTile.operator.button.remoteSupport': '遠隔支援',
  'timeLine.deviceList.title': 'デバイス一覧',
  'timeLine.deviceList.alert.login':
    '遠隔支援を行うには、端末のアプリでログインしてください',
  'timeLine.deviceList.button.setLocationInfo': '位置情報',
  'timeLine.deviceList.button.deleteDevice': '削除',
  'timeLine.deviceList.button.board': '黒板',
  'timeLine.deviceList.button.remoteSupport': '遠隔支援',
  'timeLine.deviceList.button.remoteSupportEnd': '遠隔終了',
  'timeLine.deviceList.text.setLocationInfo': '位置情報',
  'timeLine.deviceList.sp.title': 'デバイス一覧',
  'timeLine.deviceList.sp.noDevice': 'デバイスは登録されていません',
  'timeLine.deviceList.remoteSupportEnd.prompt.message': '遠隔支援終了',
  'timeLine.deviceList.remoteSupportEnd.prompt.comments.1':
    '本操作を行うと選択したデバイスが行っている遠隔作業支援が',
  'timeLine.deviceList.remoteSupportEnd.prompt.comments.2':
    '強制的に終了されます。よろしいでしょうか？',
};

export default timeLineMessages;
